/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared quickview snippet. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* Capkov redesign (capkov-rd): small scripts. Loaded with defer; none of it is critical for first paint. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1) Delivery sentence. EU: NO countdown, NO "tomorrow" and no cut-off logic (the data cannot prove it).
        The server renders the static sentence ("We ship within 1-2 business days, usually the next business day.");
        this script only hides the estimate when the selected variant is unavailable.
     ------------------------------------------------------------------ */

  /* hide the estimate when the selected variant is unavailable (same behaviour as the original capkov-eta) */
  function bindEtaVariants() {
    document.querySelectorAll('[data-rd-eta-root]').forEach(function (root) {
      var vars = [];
      try { vars = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { }
      function sel() {
        var i = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        return i && i.value ? parseInt(i.value, 10) : parseInt(root.getAttribute('data-initial') || '0', 10);
      }
      function apply() {
        var id = sel(), v = null;
        vars.forEach(function (x) { if (x.id === id) v = x; });
        root.style.display = (v && v.available === false) ? 'none' : '';
      }
      apply();
      document.addEventListener('variant:change', function () { setTimeout(apply, 0); });
      var f = document.querySelector('form[action*="/cart/add"]');
      if (f) f.addEventListener('change', apply, { passive: true });
    });
  }

  /* ------------------------------------------------------------------
     2) 2/3 pcs sets (UI above the quantity field; off until the owner creates the discount)
     ------------------------------------------------------------------ */
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var FMT = null;
  try { FMT = new Intl.NumberFormat('en-IE', { style: 'currency', currency: CUR, minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (e) { }
  function money(c) {
    var v = (c || 0) / 100;
    if (FMT) return FMT.format(v);
    return '\u20ac' + v.toFixed(2);
  }
  /* ------------------------------------------------------------------
     4) Cart: one tap adds an add-on / another piece
     ------------------------------------------------------------------ */
  function bindCartAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-rd-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var id = b.getAttribute('data-rd-add');
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { document.dispatchEvent(new Event('cart:refresh')); })
        .catch(function () { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = rdOT("could_not_add_it_please_try_again_bae1d59", "Could not add it, please try again"); })
        .then(function () { setTimeout(function () { b.disabled = false; b.removeAttribute('aria-busy'); }, 1200); });
    });
  }

  /* ------------------------------------------------------------------
     5) Builder wrapper: running total price and steps 1-2-3.
        Reads the engine state, DOM attributes as fallback; never touches the cart.
     ------------------------------------------------------------------ */
  function bindBuilder() {
    document.querySelectorAll('[data-capkov-builder]').forEach(function (root) {
      var modal = root.__capkovBuilderModal || root.querySelector('[data-capkov-modal]');
      if (!modal) return;
      var totalEl = modal.querySelector('[data-rd-btotal]');
      var stepsEl = modal.querySelector('[data-rd-bsteps]');
      if (!totalEl && !stepsEl) return;
      var cfg = {};
      try { cfg = JSON.parse((root.querySelector('[data-capkov-config]') || {}).textContent || '{}'); } catch (e) { }
      var capOnly = !(cfg.is_tote || cfg.is_apparel || cfg.kind === 'color');
      var prices = {};
      if (totalEl) { try { prices = JSON.parse(totalEl.getAttribute('data-prices') || '{}'); } catch (e) { } }
      var fPlace = parseFloat((cfg.fees || {}).placement) || 5, fColor = parseFloat((cfg.fees || {}).color) || 2.5; /* EU defaults: extra placement EUR 5, thread colour EUR 2.50 */
      var colorByPlacement = {};
      var raf = null, timer = null;

      function basePrice() {
        var i = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var id = i && i.value;
        return prices[id] || parseInt(totalEl.getAttribute('data-unit') || '0', 10);
      }
      function record() {
        var row = modal.querySelector('[data-capkov-thread-row]');
        if (!row || row.hidden) return;
        var act = modal.querySelector('[data-capkov-tabs] .capkov-b2__tab[data-active="true"]');
        var pl = act && act.getAttribute('data-placement');
        var c = row.querySelector('.capkov-b2__color[data-active="true"]');
        if (pl && c) colorByPlacement[pl] = { color: c.getAttribute('data-color') || '', paid: !!c.querySelector('.capkov-b2__color-fee') };
      }
      function update() {
        if (raf !== null) cancelAnimationFrame(raf);
        if (timer !== null) clearTimeout(timer);
        raf = timer = null;
        record();
        var tabs = modal.querySelectorAll('[data-capkov-tabs] .capkov-b2__tab');
        var filled = [];
        tabs.forEach(function (t) { if (t.getAttribute('data-capkov-filled') === 'true') filled.push(t.getAttribute('data-placement')); });
        var snapshot = typeof root.__capkovBuilderState === 'function' ? root.__capkovBuilderState() : null;
        if (snapshot) {
          filled = snapshot.selected;
          colorByPlacement = snapshot.colors;
        }
        var any = filled.length > 0;
        var extraPl = capOnly ? (snapshot ? snapshot.paid.length : Math.max(0, filled.length - 1)) : 0;
        var paidColors = {};
        if (capOnly) filled.forEach(function (p) { var c = colorByPlacement[p]; if (c && c.paid && c.color) paidColors[c.color] = 1; });
        var nCol = Object.keys(paidColors).length;
        if (totalEl) {
          var base = basePrice();
          var tot = base + extraPl * fPlace * 100 + nCol * fColor * 100;
          var priceText = money(tot);
          setText(totalEl.querySelector('[data-rd-btotal-v]'), priceText);
          var add = modal.querySelector('[data-capkov-add]');
          if (add && add.getAttribute('data-rd-price') !== priceText) add.setAttribute('data-rd-price', priceText);
          var fx = [];
          if (extraPl) fx.push(rdOT("extra_placement_27848d1", "extra placement +") + money(extraPl * fPlace * 100));
          if (nCol) fx.push(rdOT("thread_colour_b3ba240", "thread colour +") + money(nCol * fColor * 100));
          setText(totalEl.querySelector('[data-rd-btotal-fx]'), fx.length ? (rdOT("base_6679e2f", "base ") + money(base) + ', ' + fx.join(', ')) : rdOT("no_extra_charges_fd3742e", "no extra charges"));
        }
        if (stepsEl && !stepsEl.getAttribute('data-rd-own')) {   /* real step state is driven by capkov-rd-builder.js (data-rd-own) */
          var li = stepsEl.querySelectorAll('li');
          var colorChosen = Object.keys(colorByPlacement).length > 0 || cfg.kind === 'image' || !capOnly;
          var s1 = any ? 'done' : 'active', s2 = any ? (colorChosen ? 'done' : 'active') : '', s3 = (any && colorChosen) ? 'active' : '';
          [s1, s2, s3].forEach(function (s, i) { if (li[i]) li[i].setAttribute('data-state', s); });
        }
      }
      function setText(el, text) {
        // Avoid feeding our own childList observer indefinitely.
        if (el && el.textContent !== text) el.textContent = text;
      }
      function sched() {
        if (timer !== null) return;
        timer = setTimeout(update, 100);
        if (typeof requestAnimationFrame === 'function') raf = requestAnimationFrame(update);
      }
      document.addEventListener('capkov:builder-state', function (event) {
        if (event.detail && event.detail.root === root) sched();
      });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) update(); });
      window.addEventListener('pageshow', update);
      if (window.MutationObserver) new MutationObserver(sched).observe(modal, { attributes: true, childList: true, subtree: true, attributeFilter: ['data-active', 'data-capkov-filled', 'hidden', 'aria-hidden', 'data-open'] });
      modal.addEventListener('input', sched, true);
      modal.addEventListener('change', sched, true);
      modal.addEventListener('compositionend', sched, true);
      modal.addEventListener('click', sched, true);
      document.addEventListener('variant:change', function () { setTimeout(sched, 0); });
      update();
    });
  }

  /* Cart page: reload the add-ons block after a cart change (the drawer redraws itself) */
  function bindCartPage() {
    var box = document.querySelector('[data-rd-extras-page]');
    if (!box) return;
    var t = 0;
    function reload() {
      fetch(window.location.pathname, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html');
          var n = d.querySelector('[data-rd-extras-page]');
          if (n) box.innerHTML = n.innerHTML;
        }).catch(function () { });
    }
    ['cart:change', 'cart:refresh', 'cart:updated', 'line-item:change'].forEach(function (e) {
      document.addEventListener(e, function () { clearTimeout(t); t = setTimeout(reload, 700); });
    });
  }

  /* Product cards: a click anywhere on the card opens the product (not on buttons, links, forms or when selecting text) */
  function bindCardClick() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var card = e.target.closest && e.target.closest('product-card');
      if (!card) return;
      if (e.target.closest('a,button,input,select,label,summary,form,[data-no-card-click]')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      var a = card.querySelector('a[href*="/products/"]');
      if (a) a.click();
    });
  }

  /* Search: synonyms (cap / hat / snapback) - extends the suggest query with OR; no AbortController */
  function bindSearchSynonyms() {
    var groups = [['cap', 'caps', 'hat', 'hats', 'snapback', 'snapbacks', 'baseball cap', 'baseball caps', 'dad cap', 'dad hat']];
    var orig = window.fetch;
    if (!orig || window.__rdFetch) return;
    window.__rdFetch = true;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/search/suggest') > -1 && typeof input === 'string') {
          var u = new URL(url, location.origin), q = (u.searchParams.get('q') || '').trim().toLowerCase();
          groups.forEach(function (g) {
            if (g.indexOf(q) > -1) u.searchParams.set('q', '(' + g.filter(function (x, i) { return i % 2 === 0; }).join(' OR ') + ')');
          });
          input = u.pathname + u.search;
        }
      } catch (e) { }
      return orig.call(this, input, init);
    };
  }


  /* ------------------------------------------------------------------
     Round 2: add a whole set with one tap + open the cart
     ------------------------------------------------------------------ */
  function openCart() {
    try {
      var a = document.querySelector('a[aria-controls="cart-drawer"], button[aria-controls="cart-drawer"]');
      if (a) a.click();
    } catch (e) { }
  }
  function bindAddSet() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-rd-addset]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var items = [];
      try { items = JSON.parse(b.getAttribute('data-rd-addset')); } catch (er) { }
      if (!items.length) return;
      var label = b.textContent;
      b.disabled = true; b.setAttribute('aria-busy', 'true'); b.setAttribute('data-rd-spin', '1'); b.textContent = rdOT("adding_ffb2e62", "Adding…");
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { b.removeAttribute('data-rd-spin'); b.textContent = rdOT("added_9599c19", "Added ✓"); document.dispatchEvent(new Event('cart:refresh')); setTimeout(openCart, 150); })
        .catch(function () { b.removeAttribute('data-rd-spin'); b.textContent = rdOT("could_not_add_it_please_try_again_bae1d59", "Could not add it, please try again"); })
        .then(function () { setTimeout(function () { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = label; }, 2200); });
    });
  }

  /* ------------------------------------------------------------------
     Round 2: subtle scroll-in motion. Only elements below the fold, only when the visitor has not asked to reduce motion.
     ------------------------------------------------------------------ */
  function bindReveal() {
    return; /* 4. 10. (flicker): žádné odkrývání prvků po jednom (rd-pre/rd-in); obsah je vidět hned */
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var vh = window.innerHeight || 800;
    var els = [].slice.call(document.querySelectorAll('[data-rd-reveal]'));
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('rd-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('rd-pre');
      el.style.setProperty('--rd-d', ((i % 4) * 0.06) + 's');
      io.observe(el);
    });
  }


  /* ------------------------------------------------------------------
     Round 2 (performance): the header menu is inserted lazily. The mega menu and mobile panel content is in <template data-rd-lazy>,
     inserted on the first interaction with the header (hover, tap, key) or after 8 s idle after load.
     ------------------------------------------------------------------ */
  function bindLazyNav() {
    var done = false;
    function hydrate() {
      if (done) return; done = true;
      [].slice.call(document.querySelectorAll('template[data-rd-lazy]')).forEach(function (t) {
        var f = t.content.cloneNode(true);
        var par = t.parentNode; par.insertBefore(f, t); par.removeChild(t);
        /* menu-fix: AnimatedDetails drží jako contentElement <template>; po vložení přepojit na skutečný panel, jinak zůstane průhledný. */
        if (par.tagName === 'DETAILS' && 'contentElement' in par && par.lastElementChild && par.lastElementChild.tagName !== 'SUMMARY') {
          par.contentElement = par.lastElementChild;
          if (par.hasAttribute('open') || par.open) { par.contentElement.style.opacity = '1'; }
        }
      });
    }
    ['pointerdown', 'touchstart', 'mouseover', 'focusin', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (done) return;
        var t = e.target;
        if (t && t.closest && t.closest('header, store-header, .shopify-section-group-header-group, [aria-controls="header-sidebar-menu"], #header-sidebar-menu')) hydrate();
      }, { passive: true, capture: true });
    });
    function later() { setTimeout(function () { (window.requestIdleCallback || function (f) { f(); })(hydrate, { timeout: 4000 }); }, 8000); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    window.__rdHydrateNav = hydrate;
  }

  /* A custom design must not reach the cart without a design (empty order): a submit without builder properties is blocked and the builder opens. */
  function bindNoBlank() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      var guarded = f.querySelector('[data-rd-nobuy]') || (f.getAttribute('id') && document.querySelector('buy-buttons[data-rd-nobuy][form="' + f.getAttribute('id') + '"]'));
      if (!guarded) return;
      var has = [].some.call(f.querySelectorAll('input[name^="properties["]'), function (i) {
        return /^properties\[_{1,2}capkov_/.test(i.name) && i.value && !i.disabled;
      });
      if (has) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var o = document.querySelector('[data-capkov-open]'); if (o) o.click();
    }, true);
  }

  function init() {
    bindNoBlank(); bindCartPage(); bindCardClick(); bindSearchSynonyms();
    bindEtaVariants(); bindCartAdd(); bindBuilder(); bindAddSet(); bindReveal(); bindLazyNav();
  }
  /* body.rd-modal-open while any modal / drawer / viewer is open: used by CSS to hide the third-party chat bubble */
  function bindModalFlag() {
    var b = document.body, h = document.documentElement, raf = 0;
    function check() {
      raf = 0;
      var vis = function (el) { if (!el || el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false; var r = el.getBoundingClientRect(), cs = getComputedStyle(el); return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 0 && r.height > 0; };
      var els = document.querySelectorAll('dialog[open], [aria-modal="true"], .rd3d.is-open'), any = false;
      for (var i = 0; i < els.length && !any; i++) any = vis(els[i]);
      var open = any || /(^|\s)(rd3d-lock|rdc-lock|rdd-lock|rdqv-open|rdb-lock)(\s|$)/.test(b.className + ' ' + h.className);
      b.classList.toggle('rd-modal-open', open);
    }
    function sched() { if (!raf) raf = requestAnimationFrame(check); }
    try { var mo = new MutationObserver(sched); mo.observe(h, { attributes: true, attributeFilter: ['class'] }); mo.observe(b, { attributes: true, attributeFilter: ['class'] }); mo.observe(b, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-modal'] }); } catch (e) { }
    check();
  }
  bindModalFlag();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

})();
